import React, { memo } from 'react';
import { withPopUp } from '@redlink/components/atoms';
import { PlanItem, FormSection } from '@redlink/components/molecules';
import { DataEntryModalTemplate } from '@redlink/components/templates';
import { Form } from '@redlink/components/organisms';
import {
  useMutation,
  useQuery,
  getPlanQuery,
  requestForRenewPageQuery,
} from '@redlink/services';
import { useValues } from '@redlink/assets/values';
import { useLocale } from '@redlink/assets/locale';

export const PlanPage = withPopUp(
  memo(({ onDismiss, pageId }) => {
    const { staticData } = useValues();
    const { dictionary } = useLocale();

    const { loading, data: { Plan: { price = 0, finalPrice = 0 } = {} } = {} } =
      useQuery(getPlanQuery, {
        variables: { type: staticData.planSubscriptionType.renew },
      });

    const [requestForRenewPlan, { loading: requestForRenewPlanIsBusy }] =
      useMutation(requestForRenewPageQuery, {
        done: ({ RequestForRenewPage: { paymentUrl } }) =>
          (window.location.href = paymentUrl),
      });

    return (
      <DataEntryModalTemplate isBusy={loading || requestForRenewPlanIsBusy}>
        <Form
          isBusy={loading || requestForRenewPlanIsBusy}
          actions={[
            {
              title: dictionary.cancel,
              variant: 'secondary',
              onPress: onDismiss,
            },
            {
              title: dictionary.unlockPlan,
              variant: 'green',
              onPress: () => requestForRenewPlan({ pageId }),
            },
          ]}
        >
          <FormSection containerStyle={{ paddingVertical: 0 }}>
            <PlanItem
              item={{
                key: staticData.planType.pro,
                price: price / 10,
                finalPrice: finalPrice / 10,
              }}
            />
          </FormSection>
        </Form>
      </DataEntryModalTemplate>
    );
  })
);
